import { ParsedUrlQuery } from 'querystring';
import { parseAndReturnSystemParams } from 'src/utils/queryParams';
import { getPlans, Plan } from 'src/services/cart-order/plans-service';
import logger from 'logger';

/**
 * Fetches all available plans and returns the one matching the `plan` query param.
 * Returns undefined if no plan query param is present or no match is found.
 */
export const getSelectedPlan = async (
  queryParams: ParsedUrlQuery,
): Promise<Plan | undefined> => {
  const { plan: planLogicalId } = parseAndReturnSystemParams(queryParams);

  if (!planLogicalId) {
    return undefined;
  }

  try {
    const plans = await getPlans();
    return plans.find((p) => p.logicalId === planLogicalId);
  } catch (error) {
    logger.error({
      msg: 'FailedToFetchPlans',
      noticable: error as Error,
      extra: {
        planLogicalId,
      },
    });

    return undefined;
  }
};
